import React, { FC } from 'react'

import {
  DeepPartial,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
} from 'react-hook-form'
import { v4 as uuidV4 } from 'uuid'

import { Icon, ShadedButton, TextField, Txt } from 'src/components/atoms'

import { EditUserBasicInfoFormEntity } from 'src/types'

type Props = {
  register: UseFormRegister<EditUserBasicInfoFormEntity>
  fields: FieldArrayWithId<DeepPartial<EditUserBasicInfoFormEntity>, 'keywords', 'id'>[]
  append: UseFieldArrayAppend<EditUserBasicInfoFormEntity, 'keywords'>
  remove: UseFieldArrayRemove
  className?: string
}

export const UserKeywordsForm: FC<Props> = ({ register, fields, append, remove, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-flex-col tw-gap-s1">
        {fields.map((field, index) => (
          <div key={field.id} className="tw-flex tw-items-center tw-w-full">
            <TextField
              placeholder="検索キーワードを入力"
              className="tw-w-full"
              {...register(`keywords.${index}.value` as const)}
            />
            <div className="tw-pl-s0">
              <Icon
                size="--r2"
                path="trash/soft/line"
                className="tw-text-standardText-secondary hover:tw-text-standardText-primary tw-cursor-pointer"
                onClick={() => remove(index)}
              />
            </div>
          </div>
        ))}
      </div>
      <ShadedButton
        className="tw-w-full tw-mt-s2"
        onClick={() => append({ id: uuidV4(), value: '' })}
      >
        <div className="tw-flex tw-items-center">
          <Icon size="--r1" path="plus/soft/line" />
          <Txt sizeType="s" className="tw-font-bold tw-ml-s-3">
            新規追加
          </Txt>
        </div>
      </ShadedButton>
    </div>
  )
}
